export class CreateShop { 
    public maincompanyid: string;
    public pincode: string;
    public address: string;
    public break_start_time: string;
    public token_per_hour: number = 0;
    public latitude: string;
    public mobile: string;
    public end_time: string;
    public autocall: boolean = false;
    public start_time: string;
    public password: string;
    public companyid: string;
    public is_break_available: boolean = true;
    public name: string;
    public email: string;
    public break_end_time: string;
    public isUpdate: number = 0;
    public longitude: string;
    public confirmPassword: string;
    public area: string;
    public deliver_to_customer: boolean = false;
    public customer_register: boolean = false;
    public imageFilePath: string;
}
    